import { render, staticRenderFns } from "./CustomerTimeline.vue?vue&type=template&id=f890546c"
import script from "./CustomerTimeline.vue?vue&type=script&lang=js"
export * from "./CustomerTimeline.vue?vue&type=script&lang=js"
import style0 from "./CustomerTimeline.vue?vue&type=style&index=0&id=f890546c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports